module.exports = __webpack_public_path__ + "static/media/swap1.baf40ccc.svg";